import axios from "axios";

const api = axios.create({
  baseURL: 'https://filmery.onrender.com/api',
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export const authAPI = {
  register: (userData) => api.post("/auth/register", userData),
  login: (userData) => api.post("/auth/login", userData),
  getMe: () => api.get("/auth/me"),
};

export const moviesAPI = {
  getAll: () => api.get("/movies"),
  getById: (id) => api.get(`/movies/${id}`),
  create: (movieData) => api.post("/movies", movieData),
  update: (id, movieData) => api.put(`/movies/${id}`, movieData),
  delete: (id) => api.delete(`/movies/${id}`),
  getCommunityMovies: () => api.get("/movies/community"),
  getComments: (movieId) => api.get(`/movies/${movieId}/comments`),
  addComment: (movieId, commentData) =>
    api.post(`/movies/${movieId}/comments`, commentData),
};

export default api;
